import { Box, keyframes } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

const pulseKeyframes = keyframes`
  0%, 100% { opacity: 1 }
  50% { opacity: 0.3 }
`;

type DurationDotIndicatorProps = {
  color: 'aurora' | 'info';
};

export const DurationDotIndicator = ({ color }: DurationDotIndicatorProps) => {
  return (
    <Box
      sx={{
        width: t => t.spacing(1),
        height: t => t.spacing(1),
        backgroundColor: t => t.palette[color].main,
        borderRadius: borderRadius('xl'),
        animation: `${pulseKeyframes} 1.5s infinite ease-in-out`,
      }}
    />
  );
};
